import {authService} from '../index'
import tokens from '../../utils/tokens'

class Auth {
    #headers = {
        [tokens.refreshToken.key]: {
            token_type: tokens.refreshToken.key
        },
        [tokens.accessToken.key]: {
            token_type: tokens.accessToken.key
        }
    }

    auth = data => {
        return authService.patch('auth', data, {
            ...this.#headers[tokens.refreshToken.key],
            skipInterceptor: true
        })
    }

    verifyMFAChallenge = data => {
        return authService.post('auth/mfa/verification', data, {
            ...this.#headers[tokens.refreshToken.key],
            skipInterceptor: true
        })
    }

    logOut = () => {
        return authService.delete('auth', this.#headers[tokens.refreshToken.key])
    }

    updateCustomerPassword = data => {
        return authService.put('account/password', data, this.#headers[tokens.accessToken.key])
    }

    getMFAStatus = () => {
        return authService.get('mfa/status', this.#headers[tokens.accessToken.key])
    }

    updateMFAStatus = data => {
        return authService.put('mfa', data, this.#headers[tokens.accessToken.key])
    }

    verifyMFA = data => {
        return authService.post('mfa/verification', data, this.#headers[tokens.accessToken.key])
    }

    regenerateRecoveryCodes = () => {
        return authService.post('mfa/recovery-codes', {}, this.#headers[tokens.accessToken.key])
    }

    getAuthClient = (clientId, responseType, redirectUri, scopes) => {
        return authService.get(`auth/client/${clientId}?response_type=${responseType}&redirect_uri=${redirectUri}&scopes=${scopes.join('&scopes=')}`)
    }

    getRefreshToken = (exchangeKey) => {
        return authService.get(`token-exchange?exchange_key=${exchangeKey}`)
    }
}

export default new Auth()
